function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
// import firebase from 'firebase'
import firebase from 'firebase/app';
import 'firebase/auth';
import utils from '@/js/utils';
import constants from '@/js/constants';
import store from '@/store';

/**
 * @function lock   screen lock opacity (and|or) click disable
 * @function unlock screen unlock opacity (and|or) click enable
 * @function switch screen switch lock|unlock
 */

var lockScreen = {
  ELEMENT_SELECTOR: 'body',
  // css selector fortop element
  CLASS_HARD_LOCK: 'hard-lock',
  // css class in main.styl for block click
  CLASS_SOFT_LOCK: 'soft-lock',
  // css class in main.styl for decrease opacity
  STATE: '',
  removeAllClass: function removeAllClass() {
    var element = document.querySelector(this.ELEMENT_SELECTOR);
    element.classList.remove(this.CLASS_HARD_LOCK);
    element.classList.remove(this.CLASS_SOFT_LOCK);
  },
  lock: function lock() {
    var isHard = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    store.commit('app/setShowLoading', true);
    this.removeAllClass();
    var lockClass = !isHard ? this.CLASS_SOFT_LOCK : this.CLASS_HARD_LOCK;
    document.querySelector(this.ELEMENT_SELECTOR).classList.add(lockClass);
  },
  unlock: function unlock() {
    store.commit('app/setShowLoading', false);
    this.removeAllClass();
  },
  switch: function _switch() {
    var isHard = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var lockClass = !isHard ? this.CLASS_SOFT_LOCK : this.CLASS_HARD_LOCK;
    document.querySelector(this.ELEMENT_SELECTOR).classList.remove(lockClass);
  }
};
var toast = {
  success: function success(message) {
    var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Éxito';
    var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var list_path = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    store.commit('app/setToastMessage', {
      color: 'primary',
      icon: 'mdi-check-bold',
      title: title,
      subtitle: message,
      path: path,
      list_path: list_path
    });
    store.commit('app/setShowMessage', true);
  },
  error: function error(message) {
    var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Error';
    var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var list_path = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    store.commit('app/setToastMessage', {
      color: 'error',
      icon: 'icon-decline',
      title: title,
      subtitle: message,
      path: path,
      list_path: list_path
    });
    store.commit('app/setShowMessage', true);
  },
  warning: function warning(message) {
    var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Advertencia';
    var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var list_path = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    store.commit('app/setToastMessage', {
      color: 'warning',
      icon: 'mdi-alert',
      title: title,
      subtitle: message,
      path: path,
      list_path: list_path
    });
    store.commit('app/setShowMessage', true);
  },
  info: function info(message) {
    var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Información';
    var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var list_path = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    store.commit('app/setToastMessage', {
      color: 'info',
      icon: 'mdi-information',
      title: title,
      subtitle: message,
      path: path,
      list_path: list_path
    });
    store.commit('app/setShowMessage', true);
  }
};

/**
 * @param  {Array}  allMixTags  [{column, fields...}]
 * @return {Object} [{defaultFields, columnFields}]
 */
var filterDefaultTableTagsAndColumnFields = function filterDefaultTableTagsAndColumnFields(allMixTags) {
  /* Filter all tags and column fields
   :param allMixTags : file that has all the tags
   :return defaultFields :  validate if iter tag is default tpl fields and select, 'owner' is secure default tag name for validate
  :return columnFields : default dield template
  */

  if (!allMixTags || !_typeof(allMixTags).match(/object/i)) {
    return undefined;
  }
  var defaultFields = null;
  var columnFields = [];
  for (var i = 0; i < allMixTags.length; i++) {
    var tag = allMixTags[i];
    // validate if iter tag is default tpl fields and select, 'owner' is secure default tag name for validate
    if (!tag.column && tag.fields.operator) {
      // default table template
      defaultFields = tag.fields;
    } else if (tag.column) {
      // default field template
      columnFields.push(tag);
    }
  }
  return {
    defaultFields: defaultFields,
    columnFields: columnFields
  };
};

/**
 * Extract pattern from Map Fields value
 * @param  {Object} objEnvironment  Field object to evalueate
 * @param  {Object} defaultFields  Constant Mapped fields element
 * @return {String} String pattern for html
 */
var getPattern = function getPattern(objEnvironment, defaultFields) {
  try {
    // validate id env is test
    var environment = defaultFields[constants.DEFAULT_TPL_FIELDS.ENVIRONMENT.name].enumValue.displayName;
    var el_validation = objEnvironment.required.validation;
    var ENVIROMENT_VALUES = constants.DEFAULT_TPL_FIELDS['ENVIRONMENT'].enumValues; // constants ["prod", "dev", "test"]

    if (environment === ENVIROMENT_VALUES[0] || environment === ENVIROMENT_VALUES[2]) {
      // for required items cant be empty
      if (objEnvironment.required.isRequired) {
        // default validation (constants)
        if (el_validation === constants.PATTERNS_VALIDATION['ANY'] || el_validation === constants.PATTERNS_VALIDATION['ANY_FILL'] || el_validation === constants.PATTERNS_VALIDATION['ALPHANUMBER']) {
          return constants.PATTERNS_VALIDATION['NOT_NULL'];
        } else {
          return objEnvironment.required.validation;
        }
      } else {
        // null validation
        return constants.PATTERNS_VALIDATION['ANY'];
      }
    } else {
      // test require all fields
      if (el_validation === constants.PATTERNS_VALIDATION['EMAIL']) {
        // set null or email because Null is default
        return constants.PATTERNS_VALIDATION['EMAIL_OR_NULL'];
      } else {
        return objEnvironment.required.validation;
      }
    }
  } catch (e) {
    return constants.PATTERNS_VALIDATION['ANY'];
  }
};

/**
 * Extract required from Map Fields value
 * @param  {Object} objEnvironment  Field object to evalueate
 * @param  {Object} defaultFields  Constant Mapped fields element
 * @return {String} String pattern for html
 */
var getRequired = function getRequired(objEnvironment, defaultFields) {
  try {
    // validate id env is test
    var environment = defaultFields[constants.DEFAULT_TPL_FIELDS.ENVIRONMENT.name].enumValue.displayName;
    var ENVIROMENT_VALUES = constants.DEFAULT_TPL_FIELDS['ENVIRONMENT'].enumValues; // constants ["prod", "dev", "test"]

    if (environment === ENVIROMENT_VALUES[0] || environment === ENVIROMENT_VALUES[2]) {
      if (objEnvironment.required.isRequired) {
        return true; // default validation (constants)
      } else {
        return false; // null validation
      }
    } else {
      return false; // test require all fields
    }
  } catch (e) {
    return false;
  }
};

/**
 * login in firebase error: {"code":403,"data":"none","message":"Token expired, 1575306722 < 1575311744"}
 * @param  callback {function}  No async function for execute before reload page
 * @return {null}               Undefined and reload page
 */
var logoutApplication = function logoutApplication() {
  var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  // lockScreen.lock() // lock screen

  firebase.auth().signOut().then(function () {
    window.userInfo = {};
    // lockScreen.unlock()
    if (callback) {
      callback(); // callback
    } else {
      // unlock screen
      location.reload(); // reload page for clean memory objetcs
    }
  }).catch(function (e) {
    window.userInfo = {};
    utils.printError(e); // error
  });
};

/**
 * @param {function}                 callback     callback todo
 * @param {Boolean}                  getNewToken  force request new token to firefase
 * @return {function, Object, throw} [callback, errro, userInfo]
 */
var _getUserInfo = function getUserInfo() {
  var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var getNewToken = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var userLogin = firebase.auth().currentUser;

  // if user not login
  if (!userLogin) {
    return {
      userLogin: userLogin
    };
  } else if (getNewToken) {
    // if token is expired
    firebase.auth().currentUser.getIdToken(true).then(function () {
      return _getUserInfo(callback);
    }).catch(function () {
      // on error try again
      return _getUserInfo(callback);
    });
  } else {
    // Si el usuario está logeado se almacenaron sus datos en el objetog global windows
    // normal access
    var userInfo = window.userInfo || {};
    // user info is global var
    window.userInfo = window.userInfo || {};
    userInfo['email'] = userLogin.email ? userLogin.email.toLowerCase() : userLogin.email;
    userInfo['displayName'] = userLogin.displayName;
    userInfo['userLogin'] = userLogin;
    userInfo['accessToken'] = userLogin.xa || userLogin._lat || userLogin.ma;
    userInfo['localId'] = userLogin.uid;
    userInfo['loading'] = window.userInfo.loading;
    userInfo['userRoles'] = window.userInfo.userRoles || null;
    userInfo['listOrgs'] = window.userInfo.listOrgs || null;

    // not has role platform or onli has firebase login
    /* if (!userInfo.userRoles && !userInfo.loading) {
      userInfo.loading = true
      // get role in platform
      console.log(appApis)
      appApis.loginUser(userInfo.email, userInfo.accessToken, userInfo.localId).then(res => {
        userInfo.loading = false
        window.userInfo.userRoles = res.data.roles
        window.userInfo.listOrgs = res.data.list_orgs
        window.userInfo.domain = res.data.domain
         if (callback) {
          callback(window.userInfo)
        }
      }).catch(res => {
        userInfo.loading = false
        const { status = 0, data = {}} = res || {}
        if ([401, 403].indexOf(status) >= 0) {
          alert(data.message)
          logoutApplication()
        } else {
          alert('Error on server login')
        }
         if (callback) {
          callback(res)
        }
        throw res
      })
    }*/
  }
  return window.userInfo;
};

/**
 * @function {Class} helper to paginate
 */
var PaginationHelp = /*#__PURE__*/function () {
  function PaginationHelp() {
    _classCallCheck(this, PaginationHelp);
  }
  return _createClass(PaginationHelp, [{
    key: "set",
    value: function set(dataScope) {
      this.contScrollBody = '#app';
      this.contScrollElement = '#SECTION .b-table-sticky-header';
      this.dataScope = dataScope;
    }

    /**
     * @return {undefined} scroll top later load page
     */
  }, {
    key: "scrollUp",
    value: function scrollUp() {
      var self = this;
      try {
        document.querySelector(self.contScrollElement).scrollTo(0, 0);
      } catch (e) {
        document.querySelector(self.contScrollBody).scrollTo(0, 0);
      }
      return;
    }

    /**
     * @param  {Object}    vuejs "this" data binding
     * @return {undefined} send request for next items pag
     */
  }, {
    key: "next",
    value: function next() {
      var self = this;
      var nextToken = self.dataScope.queryResponse.next_page_token;
      var tokenIndex = self.dataScope.historyPageToken.index;
      if (nextToken) {
        // save token in history for go_back
        self.dataScope.historyPageToken.list.push(nextToken);
      } else {
        nextToken = self.dataScope.historyPageToken.list[tokenIndex];
      }
      self.dataScope.reloadMethod(nextToken, function (response) {
        // Set next token index
        if (response && response.code === 200) {
          self.dataScope.historyPageToken.index = ++tokenIndex;
          self.dataScope.queryResponse = response.data;
          self.scrollUp();
        }
      });
    }

    /**
     * @param  {Object}    vuejs "this" data binding
     * @return {undefined} send request for previous items pag
     */
  }, {
    key: "back",
    value: function back() {
      var self = this;
      var tokenIndex = self.dataScope.historyPageToken.index;

      // select prev token
      var prevToken = self.dataScope.historyPageToken.list[tokenIndex - 1];
      self.dataScope.reloadMethod(prevToken, function (response) {
        // Set prev token index
        if (response && response.code === 200) {
          self.dataScope.historyPageToken.index = --tokenIndex;
          self.dataScope.queryResponse = response.data;
          self.scrollUp();
        }
      });
    }

    /**
     * @param  {Object}    vuejs "this" data binding
     * @return {undefined} send request for previous items pag
     */
  }, {
    key: "first",
    value: function first() {
      var self = this;
      self.dataScope.reloadMethod(null, function (response) {
        // Set prev token index
        if (response && response.code === 200) {
          // Set prev token index
          self.dataScope.historyPageToken.index = 0;
          self.dataScope.queryResponse = response.data;
          self.scrollUp();
        }
      });
    }
  }]);
}();
/**
 * @function {Class} helper to paginate
 */
var PaginationHelpNew = /*#__PURE__*/function () {
  function PaginationHelpNew() {
    _classCallCheck(this, PaginationHelpNew);
  }
  return _createClass(PaginationHelpNew, [{
    key: "set",
    value: function set(dataScope) {
      this.contScrollBody = '#app';
      this.contScrollElement = '#SECTION .b-table-sticky-header';
      this.dataScope = dataScope;
    }

    /**
     * @return {undefined} scroll top later load page
     */
  }, {
    key: "scrollUp",
    value: function scrollUp() {
      var self = this;
      try {
        document.querySelector(self.contScrollElement).scrollTo(0, 0);
      } catch (e) {
        document.querySelector(self.contScrollBody).scrollTo(0, 0);
      }
      return;
    }

    /**
     * @return {undefined} scroll top later load page
     */
  }, {
    key: "process",
    value: function process(nextToken, tokenIndex) {
      var self = this;
      self.dataScope.disabled = true;
      self.dataScope.reloadMethod({
        nextToken: nextToken
      }, function (response) {
        // Set next token index
        if (response && response.code === 200) {
          self.dataScope.historyPageToken.index = tokenIndex;
          self.dataScope.queryResponse = response.data;
          self.scrollUp();
        }
        self.dataScope.disabled = false;
      });
    }

    /**
     * @param  {Object}    vuejs "this" data binding
     * @return {undefined} send request for next items pag
     */
  }, {
    key: "next",
    value: function next() {
      var self = this;
      var nextToken = self.dataScope.queryResponse.next_page_token;
      var tokenIndex = self.dataScope.historyPageToken.index;
      if (nextToken) {
        // save token in history for go_back
        self.dataScope.historyPageToken.list.push(nextToken);
      } else {
        nextToken = self.dataScope.historyPageToken.list[tokenIndex];
      }
      self.process(nextToken, ++tokenIndex);
    }

    /**
     * @param  {Object}    vuejs "this" data binding
     * @return {undefined} send request for previous items pag
     */
  }, {
    key: "back",
    value: function back() {
      var self = this;
      var tokenIndex = self.dataScope.historyPageToken.index;
      // select prev token
      var prevToken = self.dataScope.historyPageToken.list[tokenIndex - 1];
      self.process(prevToken, --tokenIndex);
    }

    /**
     * @param  {Object}    vuejs "this" data binding
     * @return {undefined} send request for previous items pag
     */
  }, {
    key: "first",
    value: function first() {
      var self = this;
      self.process(null, 0);
    }
  }]);
}();
/**
 * convert array Tags to know dict for default template and columns
 * @param  {Object} queryResponse  Is returned from queryService API
 * @return {Object} Object with "defaultFields" and "columnFields" extracted
 */
var combineTagsInRows = function combineTagsInRows(queryResponse) {
  /* get the response from the queries, to pass it in rows in a table
    : param queryResponse: the queries to pass to rows
     : return nombre : show date, username and file name
  */
  var responseTables = queryResponse.tables || [];
  // set tags
  for (var i = 0; i < responseTables.length; i++) {
    var table = responseTables[i];
    var tags = table.tags;
    var separeValues = filterDefaultTableTagsAndColumnFields(tags);
    table.defaultFields = separeValues.defaultFields;
    table.columnFields = separeValues.columnFields;
  }
};

// Subida masiva funciones
var obtenerNombre = function obtenerNombre(file, user) {
  /* Massive upload of functions with date name and email
    : param file: get the name
     :return nombre : show date, username and file name
  */
  var fecha = new Date().toDateString();
  var milisegundos = Date.now();
  var nombre = "temp_".concat(fecha, "_").concat(milisegundos, "_").concat(user.email, "_").concat(file.name);
  return nombre;
};
var buildDataCSV = function buildDataCSV(_ref) {
  var default_fields = _ref.default_fields,
    tags = _ref.tags,
    tableReference = _ref.tableReference,
    massive = _ref.massive;
  var parse_data = function parse_data(record) {
    if (!record) return '';
    return record.stringValue || record.boolValue !== undefined && (record.boolValue ? 'Y' : 'N') || record.enumValue && record.enumValue.displayName || '';
  };
  var columns = ['data_element_name', 'business_definition', 'transformation_logic', 'sensitive', 'type', 'length', 'valid_values', 'primary_key', 'null', 'encrypted', 'column_load_logic'];
  var DEFAULT_TPL_FIELDS = constants.DEFAULT_TPL_FIELDS;
  console.log(default_fields);
  var defaultFields = [default_fields[DEFAULT_TPL_FIELDS.ORGANIZATION.name], default_fields[DEFAULT_TPL_FIELDS.DOMAIN.name], default_fields[DEFAULT_TPL_FIELDS.SUBDOMAIN.name], default_fields[DEFAULT_TPL_FIELDS.OFFICIAL_SOURCE.name]];
  var defaultFields_2 = [default_fields[DEFAULT_TPL_FIELDS.DESCRIPTION.name], default_fields[DEFAULT_TPL_FIELDS.OPERATOR.name], default_fields[DEFAULT_TPL_FIELDS.PUBLIC.name], default_fields[DEFAULT_TPL_FIELDS.ENVIRONMENT.name], default_fields[DEFAULT_TPL_FIELDS.ZONE.name], default_fields[DEFAULT_TPL_FIELDS.AREA.name], default_fields[DEFAULT_TPL_FIELDS.BUS_DATA_STEWARD.name], default_fields[DEFAULT_TPL_FIELDS.DATA_OWNER.name], default_fields[DEFAULT_TPL_FIELDS.TECH_DATA_CUSTODIAM.name], default_fields[DEFAULT_TPL_FIELDS.TABLE_LOAD_LOGIC.name], default_fields[DEFAULT_TPL_FIELDS.TABLES_RELATIONSHIP.name], default_fields[DEFAULT_TPL_FIELDS.FINAL_TABLE.name]];
  var header = ['org', 'domain', 'subdomain', 'official_source', 'proyecto', 'dataset', 'Table', 'description', 'operator', 'public', 'env', 'zone', 'area', 'bus_data_steward', 'data_owner', 'tech_data_custodiam', 'table_load_logic', 'tables_relationship', 'final_table', 'Table1', 'Column'];
  header = header.concat(columns).join(';');
  var body = [];
  if (!massive) {
    body.push(header);
  }
  var defaultFieldsValue = defaultFields.map(function (record) {
    return parse_data(record);
  });
  var defaultFieldsValue_2 = defaultFields_2.map(function (record) {
    return parse_data(record);
  });
  var projectId = tableReference.projectId;
  var datasetId = tableReference.datasetId;
  var tableId = tableReference.tableId;
  var fileName = "".concat(projectId, "_").concat(datasetId, "_").concat(tableId, ".csv");
  var extraFieldsValue = [projectId, datasetId, tableId];
  var extraFieldsValue_2 = [tableId];
  var tables = defaultFieldsValue.concat(extraFieldsValue).concat(defaultFieldsValue_2).concat(extraFieldsValue_2);
  var _iterator = _createForOfIteratorHelper(tags.filter(function (record) {
      return record.column;
    })),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var tag = _step.value;
      var row = tables.concat([tag.column]);
      var _iterator2 = _createForOfIteratorHelper(columns),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var column = _step2.value;
          var field = '';
          field = tag.fields[column];
          row.push(parse_data(field));
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      body.push(row.map(function (h) {
        return "".concat(h);
      }).join(';'));
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var data = body.join('\n');
  return {
    data: data,
    fileName: fileName
  };
};
var saveData = function saveData(data, fileName) {
  var a = document.createElement('a');
  document.body.appendChild(a);
  a.style = 'display: none';
  var universalBOM = "\uFEFF";
  var url = 'data:text/csv; charset=utf-8,' + encodeURIComponent(universalBOM + data);
  a.href = url;
  a.download = fileName;
  a.click();
  window.URL.revokeObjectURL(url);
};
export default {
  getUserInfo: _getUserInfo,
  logoutApplication: logoutApplication,
  PaginationHelp: PaginationHelp,
  PaginationHelpNew: PaginationHelpNew,
  lockScreen: lockScreen,
  filterDefaultTableTagsAndColumnFields: filterDefaultTableTagsAndColumnFields,
  getPattern: getPattern,
  getRequired: getRequired,
  combineTagsInRows: combineTagsInRows,
  obtenerNombre: obtenerNombre,
  buildDataCSV: buildDataCSV,
  saveData: saveData,
  toast: toast
};